// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
  padding: 1rem;
  background-color: rgba(255, 255, 255, 0);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  border-radius: 20px;
}

.title {
  display: flex;
  align-items: center;
  gap: 2vw;
  justify-content: space-between;
}

.title span {
  position: relative;
  padding: 0.25rem;
  background-color: var(--ion-color-primary);
  width: 6vw;
  height: 6vw;
  border-radius: 9999px;
}

.title span .statIcon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: var(--ion-text-primary);
  stroke: var(--ion-text-primary);
  height: calc(6vw - 0.25rem);
}

.title-text {
  margin: 0rem;
  color: var(--ion-color-primary);
  font-size: 16px;
  font-weight: 600;
}

.percent {
  margin: 0rem;
  color: var(--ion-dark-primary);
  font-weight: 400;
  display: flex;
  font-size: 12px;
  justify-content: flex-end;
}

.data {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.data p {
  margin: 0rem;
  margin: 0rem;
  color: var(--ion-color-primary);
  font-size: 14px;
  font-weight: 700;
  text-align: left;
}

.data .range {
  position: relative;
  background-color: #E5E7EB;
  width: 100%;
  height: 0.5rem;
  border-radius: 0.25rem;
}

.data .range .fill {
  position: absolute;
  top: 0;
  left: 0;
  background-color: var(--ion-color-primary);
  width: 76%;
  height: 100%;
  border-radius: 0.25rem;
}`, "",{"version":3,"sources":["webpack://./src/app/components/app-stat/app-stat.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,wCAAA;EACA,mFAAA;EAGA,mBAAA;AADF;;AAIA;EACI,aAAA;EAEA,mBAAA;EACA,QAAA;EACA,8BAAA;AAFJ;;AAKA;EACE,kBAAA;EACA,gBAAA;EACA,0CAAA;EACA,UAAA;EACA,WAAA;EACA,qBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,8BAAA;EACA,+BAAA;EACA,2BAAA;AAFF;;AAKA;EACE,YAAA;EACA,+BAAA;EACA,eAAA;EACA,gBAAA;AAFF;;AAKA;EACA,YAAA;EACI,8BAAA;EACA,gBAAA;EACA,aAAA;EAEA,eAAA;EACA,yBAAA;AAHJ;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,yBAAA;AAHF;;AAMA;EACE,YAAA;EACA,YAAA;EACA,+BAAA;EACA,eAAA;EAEA,gBAAA;EACA,gBAAA;AAJF;;AAOA;EACE,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,cAAA;EACA,sBAAA;AAJF;;AAOA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,0CAAA;EACA,UAAA;EACA,YAAA;EACA,sBAAA;AAJF","sourcesContent":[".card {\n  padding: 1rem;\n  background-color: #fff0;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  // max-width: 100%;\n  // min-width: 40vw;\n  border-radius: 20px;\n}\n\n.title {\n    display: flex\n;\n    align-items: center;\n    gap: 2vw;\n    justify-content: space-between;\n}\n\n.title span {\n  position: relative;\n  padding: 0.25rem;\n  background-color: var(--ion-color-primary);\n  width: 6vw;\n  height: 6vw;\n  border-radius: 9999px;\n}\n\n.title span .statIcon {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: var(--ion-text-primary);;\n  stroke: var(--ion-text-primary);;\n  height: calc(6vw - 0.25rem);\n}\n\n.title-text {\n  margin: 0rem;\n  color: var(--ion-color-primary);\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.percent {\nmargin: 0rem;\n    color: var(--ion-dark-primary);\n    font-weight: 400;\n    display: flex\n;\n    font-size: 12px;\n    justify-content: flex-end;\n}\n\n.data {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n}\n\n.data p {\n  margin: 0rem;\n  margin: 0rem;\n  color: var(--ion-color-primary);\n  font-size: 14px;\n  // line-height: 1rem;\n  font-weight: 700;\n  text-align: left;\n}\n\n.data .range {\n  position: relative;\n  background-color: #E5E7EB;\n  width: 100%;\n  height: 0.5rem;\n  border-radius: 0.25rem;\n}\n\n.data .range .fill {\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-color: var(--ion-color-primary);\n  width: 76%;\n  height: 100%;\n  border-radius: 0.25rem;\n}\n\n// .statIcon{\n// height: 5vw;\n// width: 5vw;\n// stroke: var(--ion-text-primary);\n\n// }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
